export const data = [
	{
		name: "Stephen King",
		data: [
			["1974/01/01", 60581, "Carrie"],
			["1975/01/01", 157607, "'Salem's Lot"],
			["1977/01/01", 161321, "The Shining"],
			["1977/07/01", 53994, "Rage\xa0(Bachman)"],
			["1979/01/01", 84177, "The Long Walk(Bachman)"],
			["1979/07/01", 150623, "The Dead Zone"],
			["1980/01/01", 150863, "Firestarter"],
			["1981/01/01", 89804, "Roadwork(Bachman)"],
			["1981/07/01", 118867, "Cujo"],
			["1982/01/01", 65812, "The Running Man(Bachman)"],
			["1982/07/01", 62546, "The Dark Tower: The Gunslinger"],
			["1983/01/01", 189905, "Christine"],
			["1983/07/01", 143094, "Pet Sematary"],
			["1984/01/01", 261841, "The Talisman"],
			["1984/07/01", 95716, "Thinner(Bachman)"],
			["1986/01/01", 441156, "IT"],
			["1987/01/01", 103523, "The Eyes of the Dragon"],
			["1987/04/01", 125544, "The Dark Tower: The Drawing of the Three"],
			["1987/07/01", 112409, "Misery"],
			["1987/10/01", 256253, "The Tommyknockers"],
			["1989/01/01", 153897, "The Dark Half"],
			["1990/01/01", 467812, "The Stand: The Complete & Uncut Edition"],
			["1991/01/01", 171879, "The Dark Tower: The Waste Lands"],
			["1991/07/01", 251219, "Needful Things"],
			["1992/01/01", 124349, "Gerald's Game"],
			["1992/07/01", 94342, "Dolores Claiborne"],
			["1994/01/01", 238334, "Insomnia"],
			["1995/01/01", 173477, "Rose Madder"],
			["1996/01/01", 130364, "The Green Mile"],
			["1996/05/01", 191846, "Desperation"],
			["1996/09/01", 116012, "The Regulators(Bachman)"],
			["1997/01/01", 254432, "The Dark Tower: Wizard and Glass"],
			["1998/01/01", 200340, "Bag of Bones"],
			["1999/01/01", 61413, "The Girl Who Loved Tom Gordon"],
			["2001/01/01", 216342, "Dreamcatcher"],
			["2001/07/01", 244182, "Black House"],
			["2002/01/01", 123912, "From A Buick 8"],
			["2003/01/01", 241435, "The Dark Tower: Wolves of the Calla"],
			["2004/01/01", 126253, "The Dark Tower: Song of Susannah"],
			["2004/07/01", 272350, "The Dark Tower"],
			["2005/01/01", 33859, "The Colorado Kid"],
			["2006/01/01", 121706, "Cell"],
			["2006/07/01", 183659, "Lisey's Story"],
			["2007/01/01", 72264, "Blaze (Bachman)"],
			["2008/01/01", 204382, "Duma Key"],
			["2009/01/01", 331018, "Under the Dome"],
			["2011/01/01", 269543, "11/22/63"],
			["2012/01/01", 91598, "The Dark Tower: The Wind Through the Keyhole"],
			["2013/01/01", 80001, "Joyland"],
			["2013/07/01", 161622, "Doctor Sleep"],
			["2014/01/01", 136387, "Mr. Mercedes"],
			["2014/07/01", 120417, "Revival"],
			["2015/01/01", 123477, "Finders Keepers"],
			["2016/01/01", 118741, "End of Watch"],
			["2017/01/01", 234642, "Sleeping Beauties"],
			["2018/01/01", 165444, "The Outsider"],
			["2019/01/01", 177976, "The Institute"],
			["2020/01/01", 130500, "If It Bleeds"],
			["2021/01/01", 85820, "Later"],
			["2021/07/01", 160000, "Billy Summers"],
			["2022/01/01", 140000, "Gwendy's Final Task"],
			["2022/07/01", 200000, "Fairy Tale"],
		],
	},
	{
		name: "Robert Jordan",
		data: [
			["1982/01/01", 86112, "Conan the Invincible"],
			["1982/07/01", 71000, "Conan the Defender"],
			["1983/01/01", 80000, "Conan the Unconquered"],
			["1983/07/01", 80000, "Conan the Triumphant"],
			["1984/01/01", 71500, "Conan the Magnificent"],
			["1984/05/01", 72000, "Conan the Destroyer"],
			["1984/09/01", 72000, "Conan the Victorious"],
			["1990/01/01", 305902, "The Eye of the World"],
			["1990/11/01", 267078, "The Great Hunt"],
			["1991/10/01", 251392, "The Dragon Reborn"],
			["1992/09/01", 393823, "The Shadow Rising"],
			["1993/10/01", 354109, "The Fires of Heaven"],
			["1994/10/01", 389823, "Lord of Chaos"],
			["1996/05/01", 295028, "A Crown of Swords"],
			["1998/10/01", 226687, "The Path of Daggers"],
			["2000/11/01", 238789, "Winter's Heart"],
			["2003/01/01", 271632, "Crossroads of Twilight"],
			["2004/01/01", 122150, "New Spring"],
			["2005/10/01", 315163, "Knife of Dreams"],
		],
	},
	{
		name: "Terry Prattchet",
		data: [
			["1976/01/01", 55500, "The Dark Side of the Sun"],
			["1981/01/01", 79230, "Strata"],
			["1983/01/01", 66014, "The Colour of Magic"],
			["1986/01/01", 64371, "The Light Fantastic"],
			["1987/01/01", 66260, "Equal Rites"],
			["1987/07/01", 73018, "Mort"],
			["1988/01/01", 79222, "Sourcery"],
			["1988/07/01", 85583, "Wyrd Sisters"],
			["1989/01/01", 87931, "Pyramids"],
			["1989/07/01", 98530, "Guards! Guards!"],
			["1990/01/01", 34924, "Eric"],
			["1990/07/01", 97288, "Moving Pictures"],
			["1991/01/01", 78933, "Reaper Man"],
			["1991/07/01", 81614, "Witches Abroad"],
			["1992/01/01", 91543, "Small Gods"],
			["1992/07/01", 89017, "Lords and Ladies"],
			["1993/01/01", 94726, "Men at Arms"],
			["1994/01/01", 96139, "Soul Music"],
			["1994/07/01", 93473, "Interesting Times"],
			["1995/01/01", 85391, "Maskerade"],
			["1996/01/01", 94164, "Feet of Clay"],
			["1996/07/01", 95180, "Hogfather"],
			["1997/01/01", 105197, "Jingo"],
			["1998/01/01", 94902, "The Last Continent"],
			["1998/07/01", 98407, "Carpe Jugulum"],
			["1999/01/01", 107406, "The Fifth Elephant"],
			["1999/07/01", 120060, "The Science of Discworld"],
			["2000/01/01", 105088, "The Truth"],
			["2001/01/01", 102477, "Thief of Time"],
			["2001/05/01", 127859, "The Last Hero"],
			["2001/09/01", 63779, "The Amazing Maurice and His Educated Rodents"],
			["2002/01/01", 113096, "Night Watch"],
			["2002/07/01", 111070, "The Globe: The Science of Discworld II"],
			["2003/01/01", 72878, "The Wee Free Men"],
			["2003/07/01", 114864, "Monstrous Regiment"],
			["2004/01/01", 79291, "A Hat Full of Sky"],
			["2004/07/01", 116380, "Going Postal"],
			["2005/01/01", 109085, "Thud!"],
			["2005/07/01", 99615, "Darwin's Watch: The Science of Discworld III"],
			["2006/01/01", 87523, "Wintersmith"],
			["2007/01/01", 94830, "Making Money"],
			["2009/01/01", 134939, "Unseen Academicals"],
			["2010/01/01", 106407, "I Shall Wear Midnight"],
			["2011/01/01", 129632, "Snuff"],
			["2012/01/01", 88400, "A Blink of the Screen"],
			["2013/01/01", 107155, "Raising Steam"],
			["2013/07/01", 88000, "The Science of Discworld IV: Judgement Day"],
			["2014/01/01", 87570, "A Slip of the Keyboard"],
			["2015/01/01", 72000, "The Shepherd's Crown"],
		],
	},

	{
		name: "George R. R. Martin",
		data: [
			["1974/01/01", 57000, "A Song for Lya"],
			["1977/01/01", 100000, "Dying of the Light"],
			["1980/01/01", 99900, "Nightflyers"],
			["1982/01/01", 116000, "Windhaven"],
			["1982/07/01", 117740, "Fevre Dream"],
			["1983/01/01", 96000, "The Armageddon Rag"],
			["1986/01/01", 112000, "Tuf Voyaging"],
			["1996/08/01", 292727, "A Game of Thrones"],
			["1999/02/01", 318903, "A Clash of Kings"],
			["2000/11/01", 414604, "A Storm of Swords"],
			["2005/05/01", 32013, "The Hedge Knight"],
			["2005/11/01", 295032, "A Feast for Crows"],
			["2008/06/01", 36851, "The Sworn Sword"],
			["2010/01/01", 37120, "The Mystery Knight"],
			["2011/07/01", 414788, "A Dance with Dragons"],
			["2013/12/01", 8000, "The Princess and the Queen"],
			["2018/10/01", 180000, "Fire & Blood"],
		],
	},
	{
		name: "Steven Erikson",
		data: [
			["1998/01/01", 128000, "This River Awakens"],
			["1999/01/01", 209000, "Gardens of the Moon"],
			["2000/01/01", 272000, "Deadhouse Gates"],
			["2001/01/01", 358000, "Memories of Ice"],
			["2002/01/01", 30000, "Blood Follows"],
			["2002/07/01", 306000, "House of Chains"],
			["2004/01/01", 270000, "Midnight Tides"],
			["2004/03/01", 25000, "The Healthy Dead"],
			["2004/05/01", 30000, "The Devil Delivered"],
			["2004/08/01", 30000, "Fishin' with Grandma Matchie"],
			["2004/11/01", 30000, "When She's Gone"],
			["2006/01/01", 365000, "The Bonehunters"],
			["2007/01/01", 386000, "Reaper's Gale"],
			["2007/07/01", 25000, "The Lees of Laughter's End"],
			["2008/01/01", 30000, "Revolvo"],
			["2008/07/01", 392000, "Toll the Hounds"],
			["2009/01/01", 30000, "Crack'd Pot Trail"],
			["2009/07/01", 382000, "Dust of Dreams"],
			["2011/01/01", 385000, "The Crippled God"],
			["2012/01/01", 30000, "The Wurms of Blearmouth"],
			["2012/05/01", 30000, "The Devil Delivered and Other Tales"],
			["2012/09/01", 292000, "Forge of Darkness"],
			["2014/01/01", 100000, "Willful Child"],
			["2016/01/01", 100000, "Willful Child: Wrath of Betty"],
			["2016/05/01", 363000, "Fall of Light"],
			["2016/09/01", 30000, "The Fiends of Nightmaria"],
			["2018/01/01", 130000, "Rejoice A Knife to the Heart"],
			["2018/07/01", 100000, "Willful Child: The Search for Spark"],
			["2020/01/01", 30000, "Upon a Dark of Evil Overlords"],
			["2021/01/01", 191000, "The God is Not Willing"],
		],
	},
	{
		name: "Brandon Sanderson",
		data: [
			["2005/01/01", 201372, "Elantris"],
			["2006/01/01", 6161, "The Hope of Elantris"],
			["2006/06/01", 211959, "The Final Empire"],
			["2007/01/01", 65539, "Alcatraz vs the Evil Librarians"],
			["2007/06/01", 249522, "The Well of Ascension"],
			["2008/01/01", 65025, "The Scrivener's Bones"],
			["2008/05/01", 29453, "Defending Elysium"],
			["2008/09/01", 241889, "The Hero of Ages"],
			["2009/01/01", 59073, "The Knights of Crystallia"],
			["2009/05/01", 297502, "The Gathering Storm"],
			["2009/09/01", 196014, "Warbreaker"],
			["2010/01/01", 60577, "The Shattered Lens"],
			["2010/05/01", 384265, "The Way of Kings"],
			["2010/09/01", 327052, "Towers of Midnight"],
			["2011/01/01", 39040, "Infinity Blade: Awakening"],
			["2011/05/01", 96646, "The Alloy of Law"],
			["2011/09/01", 6815, "The Eleventh Metal"],
			["2012/01/01", 31925, "The Emperor's Soul"],
			["2012/06/01", 17910, "Legion"],
			["2013/01/01", 37681, "Infinity Blade: Redemption"],
			["2013/03/01", 17892, "Shadows for Silence in the Forests of Hell"],
			["2013/05/01", 108686, "Steelheart"],
			["2013/07/01", 9034, "Mitosis"],
			["2013/09/01", 90110, "The Rithmatist"],
			["2013/11/01", 353906, "A Memory of Light"],
			["2014/01/01", 37323, "Legion: Skin Deep"],
			["2014/03/01", 8000, "Allomancer Jak and the Pits of Eltania"],
			["2014/06/01", 18083, "Sixth of the Dusk"],
			["2014/09/01", 398238, "Words of Radiance"],
			["2015/01/01", 114776, "Shadows of Self"],
			["2015/05/01", 18268, "Perfect State"],
			["2015/09/01", 105072, "Firefight"],
			["2016/01/01", 51711, "The Dark Talent"],
			["2016/03/01", 130295, "The Bands of Mourning"],
			["2016/05/01", 44981, "Mistborn: Secret History"],
			["2016/07/01", 103548, "Calamity"],
			["2016/09/01", 51324, "Edgedancer"],
			["2016/11/01", 30000, "White Sand"],
			["2017/01/01", 25079, "Snapshot"],
			["2017/06/01", 458045, "Oathbringer"],
			["2018/01/01", 137231, "Skyward"],
			["2018/04/01", 28062, "Legion: Lies of the Beholder"],
			["2018/07/01", 51854, "Children of the Nameless"],
			["2018/10/01", 30000, "White Sand 2"],
			["2019/01/01", 140000, "Starsight"],
			["2019/06/01", 30000, "White Sand 3"],
			["2020/01/01", 30000, "Dark One"],
			["2020/05/01", 56282, "Dawnshard"],
			["2020/09/01", 460000, "Rhythm of War"],
			["2021/06/01", 40000, "Sunreach"],
			["2021/08/01", 40000, "ReDawn"],
			["2021/10/01", 150000, "Cytonics"],
			["2021/12/01", 50000, "Evershore"],
			["2022/08/01", 65000, "Bastille vs. the Evil Librarians"],
			["2022/10/01", 150000, "The Lost Metal"],
			["2023/01/01", 200000, "Secret Project #1"],
			["2023/04/01", 200000, "Secret Project #2"],
			["2023/07/01", 200000, "Secret Project #3"],
			["2023/10/01", 200000, "Secret Project #4"],
			["2023/12/01", 500000, "SA #5"],
		],
	},
	{
		name: "Patrick Rothfuss",
		data: [
			["2007/03/01", 244035, "The Name of the Wind"],
			["2011/03/01", 395000, "The Wise Man's Fear"],
			["2014/10/01", 31755, "The Slow Regard of Silent Things"],
		],
	},
	{
		name: "Jim Butcher",
		data: [
			["2000/4/1", 69745, "Storm Front"],
			["2001/1/1", 87870, "Fool Moon"],
			["2001/9/1", 104255, "Grave Peril"],
			["2002/9/1", 97440, "Summer Knight"],
			["2003/8/1", 98745, "Death Masks"],
			["2004/8/1", 114695, "Blood Rites"],
			["2004/10/1", 173130, "Furies of Calderon"],
			["2005/7/1", 182990, "Academ's Fury"],
			["2006/5/1", 132530, "Dead Beat"],
			["2006/6/1", 141520, "Proven Guilty"],
			["2006/12/1", 178205, "Cursor's Fury"],
			["2007/4/1", 123685, "White Night"],
			["2007/12/1", 170085, "Captain's Fury"],
			["2008/4/1", 120350, "Small Favor"],
			["2008/11/1", 153845, "Princeps' Fury"],
			["2009/4/1", 127600, "Turn Coat"],
			["2009/11/1", 208655, "First Lord's Fury"],
			["2010/4/1", 134560, "Changes"],
			["2010/10/1", 114985, "Side Jobs"],
			["2011/7/1", 155440, "Ghost Story"],
			["2012/11/1", 163850, "Cold Days"],
			["2014/5/1", 137605, "Skin Game"],
			["2015/9/1", 188355, "The Aeronaut's Windlass"],
			["2018/6/1", 134850, "Brief Cases"],
			["2020/7/1", 111940, "Peace Talks"],
			["2020/10/1", 136735, "Battle Ground"],
		],
	},
	{
		name: "J.R.R. Tolkien",
		data: [
			["1937/9/1", 95356, "The Hobbit"],
			["1954/7/1", 187790, "The Fellowship of the Ring"],
			["1954/11/1", 156198, "The Two Towers"],
			["1955/10/1", 137115, "The Return of the King"],
			["1966/9/1", 68000, "The Tolkien Reader"],
			["1977/9/1", 128905, "The Silmarillion"],
			["1980/1/1", 118000, "Unfinished Tales"],
		],
	},
	{
		name: "Isaac Asimov",
		data: [
			["1950/1/1", 70466, "Pebble in the Sky"],
			["1950/7/1", 69678, "I, Robot"],
			["1951/1/1", 69725, "Stars, Like Dust"],
			["1951/7/1", 69828, "Foundation"],
			["1952/1/1", 69095, "The Currents of Space"],
			["1952/5/1", 76820, "Foundation and Empire"],
			["1952/9/1", 42122, "David Starr - Space Ranger"],
			["1953/1/1", 41824, "Lucky Starr and the Pirates of the Asteroids"],
			["1953/7/1", 71804, "Second Foundation"],
			["1954/1/1", 70489, "The Caves of Steel"],
			["1954/7/1", 39371, "Lucky Starr and the Oceans of Venus"],
			["1955/1/1", 57994, "The Martian Way"],
			["1955/7/1", 68826, "The End of Eternity"],
			["1956/1/1", 39862, "Lucky Starr and the Big Sun Of Mercury"],
			["1957/1/1", 67559, "The Naked Sun"],
			["1957/5/1", 40256, "Lucky Starr and the Moons of Jupiter"],
			["1957/9/1", 65080, "Earth Is Room Enough"],
			["1958/1/1", 39936, "Lucky Starr and the Rings of Saturn"],
			["1959/1/1", 73870, "Nine Tomorrows"],
			["1964/1/1", 50650, "The Rest Of The Robots"],
			["1966/1/1", 62564, "Fantastic Voyage"],
			["1968/1/1", 84668, "Asimov's Mysteries"],
			["1969/1/1", 128697, "Nightfall & Other Stories"],
			["1972/1/1", 88339, "The Gods Themselves"],
			["1972/7/1", 216135, "The Early Asimov "],
			["1973/1/1", 110362, "Best of Isaac Asimov"],
			["1974/1/1", 69492, "Tales of the Black Widowers"],
			["1975/1/1", 70189, "Buy Jupiter and Other Stories"],
			["1976/1/1", 78160, "The Bicentennial Man & Other Stories"],
			["1980/1/1", 75067, "The Casebook Of The Black Widowers"],
			["1982/1/1", 136446, "Foundation's Edge"],
			["1982/7/1", 193280, "Complete Robot"],
			["1983/1/1", 63440, "The Norby Chronicles"],
			["1983/7/1", 141962, "Robots Of Dawn"],
			["1984/1/1", 71635, "Banquets Of The Black Widowers"],
			["1985/1/1", 140626, "Robots & Empire"],
			["1986/1/1", 137337, "Robot Dreams"],
			["1986/7/1", 142124, "Foundation and Earth"],
			["1987/1/1", 134493, "Fantastic Voyage II - Destination Brain"],
			["1988/1/1", 67967, "Azazel"],
			["1988/5/1", 130775, "Prelude to Foundation"],
			["1989/9/1", 127874, "Nemesis"],
			["1990/1/1", 145912, "Robot Visions"],
			["1990/5/1", 67911, "Puzzles of the Black Widowers"],
			["1990/9/1", 120913, "Nightfall"],
			["1993/1/1", 82936, "The Positronic Man"],
			["1993/7/1", 119912, "Forward the Foundation"],
			["1995/1/1", 105397, "Gold, The Final Science Fiction Collection"],
		],
	},
	{
		name: "Agatha Christie",
		data: [
			["1921/1/1", 56933, "The mysterious affair at Styles"],
			["1922/1/1", 75725, "The secret adversary"],
			["1923/1/1", 59158, "Murder on the links"],
			["1924/1/1", 75604, "The man in the brown suit"],
			["1925/1/1", 74754, "The secret of Chimneys"],
			["1925/7/1", 64486, "Poirot investigates"],
			["1926/1/1", 70017, "The murder of Roger Ackroyd"],
			["1927/1/1", 55782, "The big four"],
			["1928/1/1", 69860, "The mystery of the blue train"],
			["1929/1/1", 65738, "The seven dials mystery"],
			["1929/7/1", 69036, "Partners in crime"],
			["1930/1/1", 79642, "The mysterious Mr Quin"],
			["1930/7/1", 70106, "The murder at the vicarage"],
			["1931/1/1", 64248, "The Sittaford mystery"],
			["1932/1/1", 65316, "The thirteen problems"],
			["1932/7/1", 55152, "Peril at end house"],
			["1933/1/1", 65427, "The hound of death & other stories"],
			["1933/7/1", 64950, "Lord Edgware dies"],
			["1934/1/1", 63565, "Why didn't they ask Evans"],
			["1934/3/1", 51966, "Parker Pyne investigates"],
			["1934/5/1", 64528, "The Listerdale mystery & other stories"],
			["1934/8/1", 59065, "Murder on the orient express"],
			["1934/11/1", 41697, "Black coffee"],
			["1935/1/1", 58545, "Three act tragedy"],
			["1935/7/1", 60197, "Death in the clouds"],
			["1936/1/1", 58900, "The A.B.C. murders"],
			["1936/5/1", 67538, "Murder in Mesopotamia"],
			["1936/9/1", 56227, "Cards on the table"],
			["1937/1/1", 62761, "Murder in the mews"],
			["1937/4/1", 74710, "Dumb witness"],
			["1937/7/1", 78327, "Death on the Nile"],
			["1937/10/1", 78293, "Death on the Nile"],
			["1938/5/1", 59444, "Hercule Poirot's christmas"],
			["1939/1/1", 52670, "The regatta mystery & other stories"],
			["1939/7/1", 53743, "Murder is easy"],
			["1940/1/1", 55329, "Sad cypress"],
			["1940/7/1", 53580, "One two buckle my shoe"],
			["1941/1/1", 55985, "N or M"],
			["1941/7/1", 57807, "Evil under the sun"],
			["1942/1/1", 47551, "The body in the library"],
			["1942/7/1", 61601, "Five little pigs"],
			["1943/1/1", 48157, "The moving finger"],
			["1944/1/1", 56010, "Towards zero"],
			["1945/1/1", 62102, "Sparkling cyanide"],
			["1945/5/1", 61451, "Death comes as the end"],
			["1945/9/1", 54607, "Appointment & death"],
			["1947/1/1", 77627, "The labours of Hercules"],
			["1948/1/1", 67744, "The witness for the prosecution & other stories"],
			["1948/7/1", 62676, "Taken at the flood"],
			["1949/1/1", 55889, "Crooked house"],
			["1950/1/1", 60012, "Three blind mice & other stories"],
			["1950/7/1", 72332, "A murder is announced"],
			["1951/1/1", 70153, "They came to Baghdad"],
			["1951/5/1", 56890, "The under dog & other stories"],
			["1951/9/1", 72094, "The hollow"],
			["1952/1/1", 50833, "They do it & mirrors"],
			["1952/7/1", 60537, "Mrs McGinty's dead"],
			["1953/1/1", 71282, "After the funeral"],
			["1953/7/1", 58161, "A pocket full of rye"],
			["1954/1/1", 61012, "Destination unknown"],
			["1955/1/1", 57355, "Hickory dickory dock"],
			["1956/1/1", 56750, "Dead man's folly"],
			["1957/1/1", 65792, "4.50 from Paddington"],
			["1958/1/1", 68878, "Ordeal by innocence"],
			["1959/1/1", 68419, "Cat among the pigeons"],
			["1960/1/1", 70373, "The adventure of the christmas pudding"],
			["1961/1/1", 63054, "The pale horse"],
			["1961/7/1", 52469, "Double sin & other stories"],
			["1962/1/1", 69468, "The mirror crack'd from side to side"],
			["1963/1/1", 74024, "The clocks"],
			["1964/1/1", 52280, "A caribbean mystery"],
			["1965/1/1", 62641, "At Bertram's hotel"],
			["1966/1/1", 72114, "Third girl"],
			["1967/1/1", 62185, "Endless night"],
			["1968/1/1", 70559, "By the pricking of my thumbs"],
			["1969/1/1", 67417, "Hallowe'en party"],
			["1970/1/1", 68925, "Passenger to Frankfurt"],
			["1971/1/1", 75650, "The golden ball & other stories"],
			["1971/7/1", 77343, "Nemesis"],
			["1972/1/1", 60644, "Elephants can remember"],
			["1973/1/1", 75870, "Postern of fate"],
			["1974/1/1", 81072, "Poirot's early cases"],
			["1975/1/1", 56716, "Curtain"],
			["1976/1/1", 59072, "Sleeping murder"],
		],
	},
	{
		name: "Robin Hobb",
		data: [
			["1983/1/1", 78000, "Harpy's Flight"],
			["1984/1/1", 98000, "The Windsingers"],
			["1984/7/1", 60000, "The Limbreth Gate"],
			["1985/1/1", 76000, "Wizard of the Pigeons"],
			["1988/1/1", 87000, "The Reindeer People"],
			["1988/7/1", 60000, "Wolf's Brother"],
			["1989/1/1", 104000, "Luck of the Wheels"],
			["1991/1/1", 92000, "Cloven Hooves"],
			["1992/1/1", 202196, "The Gypsy"],
			["1992/7/1", 307400, "Ship of Magic"],
			["1995/1/1", 157240, "Assassin's Apprentice"],
			["1996/1/1", 260152, "Royal assassin"],
			["1997/1/1", 338737, "Assassin's quest"],
			["1999/1/1", 295365, "The Mad Ship"],
			["2000/1/1", 305753, "Ship of Destiny"],
			["2001/1/1", 238667, "Fool's Errand"],
			["2002/1/1", 254785, "Golden Fool"],
			["2003/1/1", 325436, "Fool's Fate"],
			["2005/1/1", 229145, "Shaman's Crossing"],
			["2006/1/1", 282343, "Forest Mage"],
			[
				"2008/1/1",
				262866,
				"Renegade's Magic: Book Three of the Soldier Son Trilogy",
			],
			[
				"2009/1/1",
				179666,
				"Dragon Keeper: Volume One of the Rain Wilds Chronicles",
			],
			[
				"2010/1/1",
				180362,
				"Dragon Haven: Volume Two of the Rain Wilds Chronicles",
			],
			["2011/1/1", 130905, "The Inheritance and Other Stories"],
			["2011/7/1", 116725, "City of Dragons"],
			[
				"2013/1/1",
				30305,
				"The Wilful Princess and the Piebald Prince (Unabridged)",
			],
			["2013/7/1", 140505, "Blood of Dragons"],
			["2014/1/1", 237510, "Fool's Assassin"],
			["2015/1/1", 295075, "Fool's Quest"],
			["2017/1/1", 391790, "Assassin's Fate"],
		],
	},
	{
		name: "Adrian Tchaikovsky",
		data: [
			["2008/1/1", 153000, "Empire in Black and Gold"],
			["2009/1/1", 168250, "Dragonfly Falling"],
			["2009/7/1", 120000, "Blood of the Mantis"],
			["2010/1/1", 120000, "Salute the Dark"],
			["2010/7/1", 180000, "The Scarab Path"],
			["2011/1/1", 180000, "The Sea Watch"],
			["2011/7/1", 150000, "Heirs of the Blade"],
			["2012/1/1", 150000, "The Air War"],
			["2013/1/1", 150000, "War Master's Gate"],
			["2014/1/1", 150000, "Seal of the Worm"],
			["2015/1/1", 145000, "Children of Time"],
			["2015/7/1", 183860, "Guns of the Dawn"],
			["2016/1/1", 75000, "Spiderlight"],
			["2016/7/1", 192000, "The Tiger and the Wolf"],
			["2017/1/1", 120000, "Dogs of War"],
			["2017/5/1", 136000, "The Bear and the Serpent"],
			["2017/9/1", 47000, "Ironclads"],
			["2018/1/1", 110000, "Redemption's Blade"],
			["2018/5/1", 130000, "The Hyena and the Hawk"],
			["2018/9/1", 49500, "The Expert System's Brother"],

			["2019/1/1", 153000, "Children of Ruin"],
			["2019/4/1", 180000, "Cage of Souls"],
			["2019/7/1", 43000, "Walking to Aldebaran"],
			["2019/10/1", 57400, "Made Things"],
			["2020/1/1", 160000, "The Doors of Eden"],
			["2020/7/1", 50000, "Firewalkers"],

			["2021/1/1", 39000, "The Expert System's Champion"],
			["2021/4/1", 43000, "One Day All This Will Be Yours"],
			["2021/6/1", 120000, "Bear Head"],
			["2021/8/1", 140000, "Shards of Earth"],
			["2021/11/1", 52000, "Elder Race"],

			["2022/2/1", 60000, "Day of Ascension"],

			["2022/3/1", 40000, "Ogres"],
			["2022/4/1", 140000, "Eyes of the Void"],
			["2022/10/1", 150000, "Children of Memory"],
			["2023/2/1", 40000, "And put away childish things"],
			["2023/4/1", 150000, "Lords of Uncreation"],
		],
	},
];
